import { useDeleteVoucher } from "http-hooks/voucher/useVoucher";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteVoucher({ id, onClose, setOpen }) {
  const { mutateAsync, isPending } = useDeleteVoucher();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error is already handled by the service layer (toast)
      console.error("Error deleting voucher:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Voucher"
      description="Are you sure you want to delete this Voucher? This Voucher will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
